import { UserRole } from '../features/auth/types';

export const ALL_ROLES: UserRole[] = ['Admin', 'Billing', 'Desk Admin', 'Desk Agent'];

// Single source of truth: which roles may access each route.
// Update this map to change access rules across both the router guard
// and the sidebar navigation.
export const routePermissions: Record<string, UserRole[]> = {
  '/home': ALL_ROLES,
  '/dashboard': ['Admin', 'Desk Admin'],
  '/profile': ALL_ROLES,
  '/support': ALL_ROLES,

  '/members': ['Admin', 'Desk Admin'],
  '/application-settings': ['Admin', 'Desk Admin'],
  '/api-keys': ['Admin'],
  '/application-participants': ['Admin', 'Desk Admin', 'Desk Agent'],
  '/inactive-user-requests': ['Admin', 'Desk Admin'],
  '/call-recordings': ['Admin'],
  '/chat-bot': ['Admin', 'Desk Admin'],
  '/ai-chat-bot': ['Admin', 'Desk Admin'],
  '/agents-chats': ['Desk Agent'],

  '/chat-settings': ['Admin', 'Desk Admin'],
  '/call-settings': ['Admin', 'Desk Admin'],
  '/get-started': ['Admin', 'Desk Admin'],
  '/get-started/calls': ['Admin', 'Desk Admin'],
  '/get-started/chat': ['Admin', 'Desk Admin'],
  '/get-started/bots': ['Admin', 'Desk Admin'],
  '/widget-builder': ['Admin', 'Desk Admin'],

  '/sentiment-call-analytics': ['Admin', 'Desk Admin'],
  '/sentiment-participant-analytics': ['Admin', 'Desk Admin'],
  '/sentiment-aggregate-analytics': ['Admin', 'Desk Admin'],

  '/plans-and-billing': ['Admin','Desk Admin', 'Billing', 'Desk Agent'],
};

// Returns true when the given role may access the path.
// Exact matches win; otherwise the longest registered prefix is used so nested
// routes (e.g. /get-started/calls/uikit/react) inherit parent permissions.
// Paths not present in the map are treated as open to any authenticated user.
export const hasRouteAccess = (role: string | undefined, path: string): boolean => {
  const exact = routePermissions[path];
  if (exact) {
    return !!role && exact.includes(role as UserRole);
  }

  const matchedKey = Object.keys(routePermissions)
    .filter((key) => path === key || path.startsWith(`${key}/`))
    .sort((a, b) => b.length - a.length)[0];

  if (!matchedKey) return true;
  return !!role && routePermissions[matchedKey].includes(role as UserRole);
};
